import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '@/app/components/translations/Translation';
import { useFetchHotelStatic } from './useFetchHotelStatic';

export function useRoomAvailabilityAlertLabel(roomsLeft: number) {
  const { translateBaseOnCount } = useTranslation();
  const { localization } = usePageWrapperData();
  const { data: hotelStaticData } = useFetchHotelStatic();
  const accommodationType = hotelStaticData?.accommodationType;

  const show = roomsLeft >= 1 && roomsLeft <= 5;

  const labelKeyMap =
    accommodationType === 'HOTELS'
      ? {
          singular: 'vacation.select.details.rooms.left.one',
          plural: 'vacation.select.details.rooms.left.several',
          pluralSpecial: 'vacation.select.details.rooms.left.plural2',
        }
      : {
          singular: 'vacation.select.details.accommodation.left.one',
          plural: 'vacation.select.details.accommodation.left.several',
          pluralSpecial: 'vacation.select.details.accommodation.left.several2',
        };

  const label = translateBaseOnCount(labelKeyMap, roomsLeft, localization.locale, {
    rooms: roomsLeft.toString(),
  });

  return { show, label };
}
